
<template>
  <div class="atividades-rfilancamentos ml-4 mr-4">
    <b-form>
      <b-row>
        <b-col cols="6">
          <label for="select-empresa">Empresa</label>
          <multiselect
            id="selecao-empresa-sol"
            v-model="value_empresa"
            required
            :options="empresas"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            @close="loadFiliais()"
            :preserve-search="true"
            placeholder="Selecione a empresa"
            label="empresa"
            track-by="empresa"
            name="empresa"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Empresa selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <LoadingModal v-if="isLoading" />

        <b-col cols="3">
          <label for="input-busca">Pesquisa no grid </label>
          <b-form-input
            id="buscamonitoramento"
            v-model="search"
            required="required"
            placeholder="Nº OAB / NOME / ESCRITÓRIO"
          ></b-form-input>
        </b-col>

        <b-col cols="1">
          <br />
          <b-button
            variant="warning"
            block
            class="mt-2 mr-2"
            v-b-modal.ModaleditarAdvogado
            >Novo</b-button
          >
        </b-col>
      </b-row>
    </b-form>

    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>
    <!--tbl de dados -->
    <b-table
      small
      hover
      striped
      sticky-header="100%"
      :items="itemsFiltered"
      :fields="fieldsCliFor"
    >
      <template slot="cell(actions)" slot-scope="data">
        <b-button
          @click="putAdv(data.item), loadEscritorios()"
          title="Editar advogado"
          size="sm"
          variant="primary"
          class="mr-2 mt-2"
          v-b-modal.ModaleditarAdvogado
        >
          <i class="fa fa-pencil"></i>
        </b-button>
      </template>
    </b-table>
    <b-pagination
      size="xl"
      v-model="page"
      :total-rows="count"
      :per-page="limitcarro"
    ></b-pagination>

    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
    <div>
      <b-modal
        id="ModaleditarAdvogado"
        centered
        cancel-title="Fechar"
        @cancel="loadAdvogados()"
        @close="loadAdvogados()"
        hide-footer
        size="xl"
        title="Cadastro de advogado"
        no-close-on-esc
        no-close-on-backdrop
      >
        <!-- -->
        <div>
          <b-row>
            <!--

              <b-col cols="7">
                <label for="input-filial">Empresa</label> 
                <div>                
                  <b-form-select   
                    id="fun-empresa"               
                    v-model="advogado.id_empresa"                    
                    required                                                   CNPJ
                    :options="empresas"
                    class="mb-3 "
                    text-field="empresa" 
                    @change="loadFiliais()"                                           
                  >                
                  </b-form-select>
                </div>
              </b-col>


              <b-col cols="5">
              <label for="input-filial">Filial</label>
              <div>                
                <b-form-select   
                  id="fun-filial"               
                  v-model="advogado.id_filial"                    
                  required                                                   
                  :options="filiais"
                  class="mb-3 "
                  text-field="filial"                                            
                >                
                </b-form-select>
              </div>            
            </b-col>
-->

            <b-col cols="3" class="mb-2 mt-6">
              <label for="input-registro">INSCRIÇÃO OAB</label>
              <b-form-input
                @keyup.enter="loadCliFor()"
                v-model="advogado.inscricao_oab"
                required
                placeholder="Nº da OAB"
                v-b-tooltip.hover
                title="Digite o Nº da OAB"
              ></b-form-input>
            </b-col>

            <b-col cols="3" class="mb-2 mt-6">
              <label for="input-registro">SECCIONAL</label>
              <b-form-input
                @keyup.enter="loadCliFor()"
                v-model="advogado.seccional"
                required
                placeholder="SP"
                v-b-tooltip.hover
                title="Digite a UF da OAB"
              ></b-form-input>
            </b-col>

            <b-col cols="6" class="mb-2">
              <label for="input-live">SUBSEÇÃO</label>
              <b-form-input
                v-model="advogado.subsecao"
                placeholder="Digite a razão social da empresa"
              ></b-form-input>
            </b-col>

            <b-col cols="5" class="mb-2">
              <label for="input-live">NOME </label>
              <b-form-input
                v-model="advogado.nome"
                placeholder=""
              ></b-form-input>
            </b-col>

            <b-col cols="2">
              <label for="input-status">ORIGEM</label> {{ advogado.tipo_id }}
              <div>
                <b-form-select
                  v-model="advogado.tipo_id"
                  required
                  :options="origens"
                  @change="loadEscritorios()"
                  class="mb-3"
                  text-field="escritorio"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="5">
              <label for="input-status">ESCRITÓRIO</label> --
              {{ advogado.escritorio_id }}
              <div>
                <b-form-select
                  v-model="advogado.escritorio_id"
                  required
                  :options="escritorios"
                  class="mb-3"
                  text-field="nome"
                >
                </b-form-select>
              </div>
            </b-col>

            <!-- endereço  -->

            <b-col cols="2" class="mb-2">
              <label for="input-live">CEP</label>
              <b-form-input
                v-model="advogado.cep"
                placeholder="Digite o CEP"
              ></b-form-input>
            </b-col>

            <b-col cols="5" class="mb-2 mt-6">
              <label for="input-registro">LOGRADOURO</label>
              <b-form-input
                v-model="advogado.logradouro"
                required
                placeholder="Informe o endereço"
                v-b-tooltip.hover
                title="Informe o endereço"
              ></b-form-input>
            </b-col>

            <b-col cols="2" class="mb-2">
              <label for="input-live">NUMERO</label>
              <b-form-input
                v-model="advogado.numero"
                placeholder="Digite o número"
              ></b-form-input>
            </b-col>

            <b-col cols="3" class="mb-2">
              <label for="input-live">COMPLEMENTO</label>
              <b-form-input
                v-model="advogado.complemento"
                placeholder="Digite o nome fantasia"
              ></b-form-input>
            </b-col>

            <!-- bairoo  -->
            <b-col cols="3" class="mb-2 mt-6">
              <label for="input-registro">BAIRRO</label>
              <b-form-input
                v-model="advogado.bairro"
                required
                placeholder="informe o bairro"
                v-b-tooltip.hover
                title="Informe o bairro"
              ></b-form-input>
            </b-col>

            <b-col cols="5" class="mb-2">
              <label for="input-live">MUNICIPIO</label>
              <b-form-input
                v-model="advogado.municipio"
                placeholder="Digite o número"
              ></b-form-input>
            </b-col>

            <b-col cols="1" class="mb-2">
              <label for="input-live">UF</label>
              <b-form-input
                v-model="advogado.uf"
                placeholder="UF"
              ></b-form-input>
            </b-col>

            <!-- EMAIL  -->
            <b-col cols="3" class="mb-2 mt-6">
              <label for="input-registro">EMAIL</label>
              <b-form-input
                v-model="advogado.email"
                required
                placeholder="Nº do CNPJ"
                v-b-tooltip.hover
                title="Informe o nome"
              ></b-form-input>
            </b-col>

            <b-col cols="6" class="mb-2">
              <label for="input-live">SITE</label>
              <b-form-input
                v-model="advogado.site"
                placeholder="Obs "
              ></b-form-input>
            </b-col>

            <b-col cols="3" class="mb-2">
              <label for="input-live">TELEFONE</label>
              <b-form-input
                v-model="advogado.telefone"
                placeholder="Digite o número"
              ></b-form-input>
            </b-col>

            <b-col cols="3" class="mb-2">
              <label for="input-live">CELULAR</label>
              <b-form-input
                v-model="advogado.celular"
                placeholder=""
              ></b-form-input>
            </b-col>
          </b-row>

          <b-row class="mt-2 mb-2"> </b-row>

          <b-row class="mt-2">
            <b-col cols="3">
              <label for="input-live">DATA CADASTRO</label>
              <b-input-group-text>{{
                advogado.dt_cadastro != null
                  ? moment(advogado.dt_cadastro)
                      .format("DD/MM/YYYY HH:mm")
                      .replace("Data inválida", "-")
                  : "-"
              }}</b-input-group-text>
            </b-col>

            <b-col cols="3">
              <label for="input-live">DATA ALTERAÇÃO</label>
              <b-input-group-text>{{
                advogado.dt_cadastro != null
                  ? moment(advogado.dt_alteracao)
                      .format("DD/MM/YYYY HH:mm")
                      .replace("Data inválida", "-")
                  : "-"
              }}</b-input-group-text>
            </b-col>

            <b-col cols="6" class="mb-2">
              <label for="input-live">OBSERVAÇÃO</label>
              <b-form-input
                v-model="advogado.observacao"
                placeholder="Obs "
              ></b-form-input>
            </b-col>
          </b-row>

          <b-button class="mt-3" variant="success" block @click="postAdvogado()"
            >Gravar</b-button
          >
        </div>
      </b-modal>
    </div>
    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment from "moment";
import { mapState } from "vuex";
import LoadingModal from "../utilitarios/LoadingModal";

export default {
  computed: {
    ...mapState(["user"]),

    getStyle() {
      return {
        color:
          this.advogado.situacao !== "ATIVA" && this.advogado.situacao != null
            ? "red"
            : "", // Fonte vermelha se não for 'ATIVA'
        background:
          this.advogado.situacao !== "ATIVA" && this.advogado.situacao != null
            ? "yellow"
            : "", // Background amarelo se não for 'ATIVA'
      };
    },

    itemsFiltered() {
      let valorefu = [];
      valorefu = this.objAdvogados.filter((item) => {
        const oab = item.nome || ""; // devido alguns valores retornarem null se faz necessario a substituição para não dar erro no filtro
        const nome = item.nome || "";
        const escritorio = item.escritorio || "";
        return (
          oab.indexOf(this.search) > -1 ||
          nome.indexOf(this.search) > -1 ||
          escritorio.indexOf(this.search) > -1
        );
      });
      return valorefu;
    },
  },

  name: "FuncionarioCadastro",

  data: function () {
    return {
      empresa: {},
      empresas: [], // [] lista
      filial: {},
      filiais: [], // [] lista
      clifors: [],
      clifor: {},
      ceps: [],
      objAdvogados: [],
      advogado: {},
      value_cnpj: "",
      areas: [],
      tipos: [],
      origens: [],
      escritorios: [],
      search: "",
      /*
            mode: 'save',
            carregando: false,
            atualizando: false,              
            page: 1,
            limitcarro: 0,
            count: 0,
            valor_empresa:'',                                     
            selected: null,
  */
      fieldsCliFor: [
        { key: "empresa_id", label: "EMPRESA", sortable: true },
        { key: "inscricao_oab", label: "OAB", sortable: true },
        { key: "seccional", label: "SECCIONAL", sortable: true },
        { key: "nome", label: "Nome", sortable: true },
        { key: "municipio", label: "MUNICIPIO", sortable: true },
        { key: "uf", label: "UF", sortable: true },
        { key: "telefone", label: "TELEFONE", sortable: true },
        { key: "celular", label: "CELULAR", sortable: true },
        { key: "email", label: "E-MAIL", sortable: true },
        {
          key: "dt_cadastro",
          label: "DATA CADASTRO",
          sortable: true,
          formatter: (value, key, itemsFiltered) => {
            return moment(itemsFiltered.dt_cadastro)
              .format("DD/MM/YYYY HH:MM")
              .replace("Data inválida", "-");
          },
        },
        { key: "actions", label: "Ações" },
      ],
    };
  },

  components: {
    Multiselect,
    LoadingModal,
  },

  methods: {
    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },

    loadEmpresa() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios
        .get(url, { params })
        .then((res) => {
          this.empresas = res.data.map((emp) => {
            return {
              ...emp,
              value: emp.id_empresa,
              empresa: emp.nomeempresarial,
              id_filial_erp: emp.id_filial_erp,
            };
          });
        })
        .catch(showError);
    },

    loadAdvogados() {
      let params = {
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
        empresa_id: `${this.user.id_grupo_empresa}`,
        origem: "listagem",
      };
      const url = `${baseApiUrl}/jur/advogados`;
      axios
        .get(url, { params })
        .then((res) => {
          this.objAdvogados = res.data;
        })
        .catch(showError);
    },

    postAdvogado() {
      //const partesData = this.advogado.abertura.split('/');
      // Reorganizar as partes da data no formato YYYY-MM-DD
      //const dataFormatada = `${partesData[2]}-${partesData[1]}-${partesData[0]}`;

      let corpo = {
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
        id_funcionario: `${this.user.id_funcionario}`,
        empresa_id: `${this.user.id_empresa}`,
        id: `${this.advogado.id}`,
        inscricao_oab: `${this.advogado.inscricao_oab}`,
        seccional: `${this.advogado.seccional}`,
        subsecao: `${this.advogado.subsecao}`,
        nome: `${this.advogado.nome}`,
        logradouro: `${this.advogado.logradouro}`,
        numero: `${this.advogado.numero}`,
        municipio: `${this.advogado.municipio}`,
        bairro: `${this.advogado.bairro}`,
        uf: `${this.advogado.uf}`,
        cep: `${this.advogado.cep}`,
        email: `${this.advogado.email}`,
        telefone: `${this.advogado.telefone}`,
        celular: `${this.advogado.celular}`,
        complemento: `${this.advogado.complemento}`,
        site: `${this.advogado.site}`,
        contato: `${this.advogado.contato}`,
        tipo_id: `${this.advogado.tipo_id}`,
        escritorio_id: `${this.advogado.escritorio_id}`,
        observacao: `${this.advogado.observacao}`,
      };
      const url = `${baseApiUrl}/jur/advogados`;
      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess(),
            (this.advogado = {}),
            this.loadAdvogados();
        })
        .catch(showError);
    },

    loadFiliais() {
      let params = {
        id_grupo_empresa: `${this.user.id_empresa}`,
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg, // O código comentado foi removido
      };

      const url = `${baseApiUrl}/ctr/empresa/filial`;
      axios
        .get(url, { params })
        .then((res) => {
          this.filiais = res.data.map((fil) => {
            return { ...fil, value: fil.id_filial_erp, filial: fil.filial }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    loadArea() {
      let corpo = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
      };
      const url = `${baseApiUrl}/fin/area`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.areas = res.data.map((emp) => {
            return { ...emp, value: emp.id, area: emp.area };
          });
        })
        .catch(showError);
    },

    loadTipo() {
      let corpo = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
      };
      const url = `${baseApiUrl}/fin/tipo`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.tipos = res.data.map((emp) => {
            return { ...emp, value: emp.id, tipo: emp.tipo };
          });
        })
        .catch(showError);
    },

    loadEscritorioOrigens() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.psg, // O código comentado foi removido
      };
      const url = `${baseApiUrl}/jur/escritoriotipo`;
      axios
        .get(url, { params })
        .then((res) => {
          this.origens = res.data.map((emp) => {
            return { ...emp, value: emp.id, area: emp.escritorio };
          });
        })
        .catch(showError);
    },

    async consultarCNPJ() {
      let corpo = {
        cnpj: `${this.value_cnpj}`,
      };

      const url = await `${baseApiUrl}/cnpj`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.advogado = res.data;
        })
        .catch(showError);
    },

    async loadCep() {
      let corpo = {
        cep: `${this.clifors.cnpj}`,
      };
      const url = await `${baseApiUrl}/viacep`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.ceps = res.data;
        })
        .catch(showError);
    },

    putAdv(advogado) {
      this.advogado = { ...advogado };
    },

    async loadCliFor() {
      let params = {
        psg: this.user.psg, // O código comentado foi removido
        empresa_id: `${this.user.id_empresa}`,
        cnpj: `${this.advogado.cnpj}`,
        origem: "busca",
      };
      const url = await `${baseApiUrl}/fin/clifor`;
      axios
        .get(url, { params })
        .then((res) => {
          this.advogado = res.data;
        })
        .catch(showError);
    },

    async loadEscritorios() {
      let params = {
        psg: this.user.psg, // O código comentado foi removido
        origem: "advogado",
        empresa_id: `${this.user.id_empresa}`,
        escritorio_id: `${this.advogado.tipo_id}`,
      };
      const url = await `${baseApiUrl}/fin/clifor`;
      axios
        .get(url, { params })
        .then((res) => {
          this.escritorios = res.data.map((emp) => {
            return { ...emp, value: emp.id, escritorio: emp.escritorio };
          });
        })
        .catch(showError);
    },

    reset() {
      //this.advogado = []
    },
  },

  watch: {
    page() {
      this.loadVeiculos();
    },
  },

  mounted() {
    this.loadEmpresa();
    this.loadEscritorioOrigens();
    this.loadAdvogados();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
#selecaostatusx {
  font-size: 0.7em;
}
</style>
